let csrfTokenPromise = null;

const isSameOriginRequest = (url) => {
  try {
    return new URL(url, window.location.origin).origin === window.location.origin;
  } catch {
    return false;
  }
};

const getCsrfToken = async () => {
  if (!csrfTokenPromise) {
    csrfTokenPromise = fetch("/libs/granite/csrf/token.json", { credentials: "same-origin" })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => data?.token || "")
      .catch((error) => {
        console.error("Fetch CSRF token error:", error);
        csrfTokenPromise = null;
        return "";
      });
  }

  return csrfTokenPromise;
};

const addCsrfToken = async (headers, url, auth) => {
  if (auth || !isSameOriginRequest(url)) {
    return;
  }

  const token = await getCsrfToken();
  if (token) {
    headers["CSRF-Token"] = token;
  }
};

bcl.ajax = {
  async getRequest(item, url, callback, itemCallback, setHeader, errorCallback) {
    try {
      const headers = setHeader ? { "X-Requested-With": "XMLHttpRequest" } : {};
      const res = await fetch(url, { method: "GET", headers, credentials: "same-origin" });
      const data = await res.text();

      const mockRequest = {
        status: res.status,
        statusText: res.statusText,
        responseURL: res.url,
        readyState: 4,
        responseText: data,
        response: data,
        getResponseHeader: (h) => res.headers.get(h),
      };

      if (res.ok) {
        if (item) {
          item.innerHTML = data;
        }

        if (callback) {
          if (typeof callback === "string") {
            bcl.u.executeFunctionByName(callback, window, mockRequest, item, itemCallback);
          } else if (typeof callback === "function") {
            callback(mockRequest, itemCallback);
          }
        }

        if (item) {
          document.dispatchEvent(new CustomEvent("ajax-executed", { detail: item }));
        }
      } else {
        bcl.u.removeBhgLoading();
        if (errorCallback) {
          errorCallback(itemCallback, mockRequest);
        }
      }
    } catch (error) {
      console.error("Fetch GET error in url:", url);
      console.error("GET error details:", error);
      bcl.u.removeBhgLoading();
      if (errorCallback) {
        errorCallback(itemCallback, error);
      }
    }
  },

  async postRequest(obj) {
    const { data = {}, url, contentType, errorCallback, auth } = obj;
    if (!url) {
      return;
    }

    const isJson = contentType === "json";
    const headers = {
      "Content-Type": isJson ? "application/json" : "application/x-www-form-urlencoded",
    };

    if (auth) {
      headers.Authorization = auth;
    }
    await addCsrfToken(headers, url, auth);

    const formattedData = isJson ? JSON.stringify(data) : bcl.u.serializeObject(data);

    try {
      const res = await fetch(url, { method: "POST", headers, body: formattedData, credentials: "same-origin" });
      const text = await res.text();

      const mockRequest = {
        status: res.status,
        statusText: res.statusText,
        responseURL: res.url,
        readyState: 4,
        responseText: text,
        response: text,
        getResponseHeader: (h) => res.headers.get(h),
      };

      this.onLoad(obj, mockRequest);
    } catch (error) {
      console.error("Fetch POST error in url:", url);
      console.error("POST error details:", error);
      if (errorCallback) {
        errorCallback(obj.itemCallback, error);
      }
    }
  },

  async putRequest(obj) {
    const { data, url, contentType, errorCallback } = obj;
    if (!url) {
      return;
    }

    const isBearer = contentType.includes("Bearer");
    const headers = isBearer ? { "Content-Type": "application/json", Authorization: contentType } : {};
    await addCsrfToken(headers, url, isBearer);

    try {
      const res = await fetch(url, { method: "PUT", headers, body: isBearer ? JSON.stringify(data) : data, credentials: "same-origin" });
      const text = await res.text();

      const mockRequest = {
        status: res.status,
        statusText: res.statusText,
        responseURL: res.url,
        readyState: 4,
        responseText: text,
        response: text,
        getResponseHeader: (h) => res.headers.get(h),
      };

      this.onLoad(obj, mockRequest);
    } catch (error) {
      console.error("Fetch PUT error in url:", url);
      console.error("PUT error details:", error);
      if (errorCallback) {
        errorCallback(obj.itemCallback);
      }
    }
  },

  onLoad(obj, request) {
    const { callback, itemCallback, errorCallback } = obj;

    if (request.status >= 200 && request.status < 400 && callback) {
      if (typeof callback === "string") {
        bcl.u.executeFunctionByName(callback, window, request, itemCallback);
      } else if (typeof callback === "function") {
        callback(request, itemCallback);
      }
    }

    if (request.status >= 400 && typeof errorCallback === "function") {
      errorCallback(request, itemCallback);
    }
  },
};
